export const en = {
    documentTitle: 'HOW2AI',
    languageLabel: 'EN',

    landingHeading: 'Become A Master Of AI',
    landingBody: [
        'Learn practical AI tools, prompts, and',
        'workflows you can use at work, in',
        'business, and every day.'
    ],
    toolsCaption: '+ much more',
    subscriptionLabel: 'SUBSCRIPTION OPTION',
    priceLine: 'Price is 10.70 baht per day.',
    subscribeCta: 'SUBSCRIBE NOW',
    customerService: [
        'Customer Service: For more information, please call',
        '02-322-1556 (Mon-Fri, 9:00 AM - 5:00 PM).'
    ],
    termsLink: 'Terms & Conditions',

    thankYouHeading: 'You Are Subscribed',
    thankYouBody: [
        'Welcome to HOW2AI.',
        'You can start learning right away.'
    ],
    thankYouSummary: [
        {label: 'Subscription', value: '10.70 baht per day'},
        {label: 'Trial', value: '1 day free'},
        {label: 'Renews', value: 'Daily until cancelled'}
    ],
    thankYouCta: 'START LEARNING',

    errorHeading: 'Something Went Wrong',
    errorBody: [
        'We could not complete your subscription.',
        'Please try again.'
    ],
    errorCta: 'TRY AGAIN',
};
